/*
    Copyright (C) 2023 - Wheel and Brake - Southwest Airlines
*/
import { Button, Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import Select from "react-select";
import "./Tag.css";
import FieldValidation from "../commons/FieldValidation";
import WnbModal from "../commons/WnbModalAlert";
import { getAllActive } from "../../../backend/read/GetAllActive";
import { useNavigate } from 'react-router-dom';
import WnbModalSuccess from "../commons/WnbModalSuccess";
import WnbModalError from "../commons/WnbModalError";
import WnbModalLoading from "../commons/WnbModalLoading";
import { create } from "../../../backend/create/Create";
import {ACCESS_TOKEN_KEY} from "../../../utilities/Constants";
import {decodeToken} from "../../../utilities/auth/Introspect";

const TagForm = (props) => {

  const [stationCodes, setstationCodes] = useState(props.stationCodes || []);
  const [printer, setPrinter] = useState(props.printer || "");
  const [effectivities, setEffectivities] = useState(props.effectivities || []);
  const [parts, setParts] = useState(props.parts || "");
  const [partValue, SetPartValue] = useState([]);
  const [dropDownPartValues, SetDropDownPartValues] = useState([]);
  const [printerValue, setPrinterValue] = useState([]);
  const [isWheelOrBreak, setIsWheelOrBreak] = useState("")

  const [ftnValue, setFtnValue] = useState(props.ftnValue || "");
  const [validFtnValue, setValidFtnValue] = useState(true);
  const [validationMessageForFTNWO, setValidationMessageForFTNWO] = useState("");
  const [ftnValidationType, setFtnValidationType] = useState("");

  const [obValue, setObValue] = useState(props.obValue || "");
  const [validObValue, setValidObValue] = useState(true);
  const [validationMessageForOB, setValidationMessageForOB] = useState("");
  const [obValueValidationType, setObValidationType] = useState("");

  const [ibValue, setIbValue] = useState(props.ibValue || "");
  const [validIbValue, setValidIbValue] = useState(true);
  const [ibValueValidationMessage, setIbValueValidationMessage] = useState("");
  const [ibValueValidationType, setIbValueValidationType] = useState("");

  const [snValue, setSNValue] = useState(props.snValue || "");
  const [validSnValue, setValidSnValue] = useState(true);
  const [snValueValidationMessage, setSnValueValidationMessage] = useState("");
  const [snValidationType, setSnValidationType] = useState("");

  const [showAlert, setShowAlert] = useState(false);

  const [partDisabled, setPartDisabled] = useState(true);

  const [showSaveAlert, setShowSaveAlert] = useState(false);
  const [saveMessage, setSaveMessage] = useState("");
  const [saveErrorMessage, setSaveErrorMessage] = useState("");
  const [showNotSavedAlert, setShowNotSavedAlert] = useState(false);
  const [isPrinting, setIsPrinting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => { getAllActive("EFFECTIVITY").then(res => (JSON.parse(res.body.data).Items)) }, []);
  useEffect(() => { getAllActive("PARTS").then(res => SetPartValue(JSON.parse(res.body.data).Items)) }, []);
  useEffect(() => { getAllActive("PRINTERS").then(res => setPrinterValue(JSON.parse(res.body.data).Items)) }, []);

  const compare = (a, b) => {
    return a.label > b.label ? 1 : b.label > a.label ? -1 : 0;
  }

  const onChangeSN = (event) => {
    const value = event.target.value;
    const isValidSn = value.match(/[^A-Za-z0-9\s/-]/gi);
    let newBreakSNValue = value.replace(/[^A-Za-z0-9\s/-]/gi, "");
    const attemptExceed = newBreakSNValue.length > 20;
    newBreakSNValue = newBreakSNValue.substring(0, 20);
    setSNValue(newBreakSNValue);
    if (isValidSn) {
      setSnValidation(false, "Brake S/N is not valid. The Brake S/N cannot contain special characters.");
    } else if (attemptExceed) {
      setSnValidation(false, "Brake S/N is not valid. Please enter an Brake S/N that is 20 characters or less.");
    }
  };

  const setSnValidation = (valid, message, type) => {
    setValidSnValue(valid);
    setSnValueValidationMessage(message || "");
    setSnValidationType(type || "error");
  };

  const closeSnError = () => {
    setSnValidation(true);
  };

  const onChangeFTNWO = (event) => {
    const value = event.target.value;
    const isValidFtnwo = value.match(/[^A-Za-z0-9\s-]/gi);
    let newFtnWoValue = value.replace(/[^A-Za-z0-9\s-]/gi, "");
    const attemptExceed = newFtnWoValue.length > 20;
    newFtnWoValue = newFtnWoValue.substring(0, 20);
    setFtnValue(newFtnWoValue);
    if (isValidFtnwo) {
      setFtnValidation(false, "FTN or WO is not valid. FTN or WO cannot contain special characters.");
    } else if (attemptExceed) {
      setFtnValidation(false, "FTN or WO is not valid. Please enter a FTN or WO value that is 20 characters or less.");
    }
  };

  const closeFTNValueError = () => {
    setFtnValidation(true);
  };

  const setFtnValidation = (valid, message, type) => {
    setValidFtnValue(valid);
    setValidationMessageForFTNWO(message || "");
    setFtnValidationType(type || "error");
  };

  const onChangeIbValue = (event) => {
    const value = event.target.value;
    const hasInvalidChar = value.match(/[^A-Za-z0-9\s/-]/gi);
    let newIbValue = value.replace(/[^A-Za-z0-9\s/-]/gi, "");
    const attemptExceed = newIbValue.length > 20;
    newIbValue = newIbValue.substring(0, 20);
    setIbValue(newIbValue);
    if (hasInvalidChar) {
        setIbValidation(false, "IB S/N is not valid. The IB S/N cannot contain special characters.");
    } else if (attemptExceed) {
        setIbValidation(false, "IB S/N is not valid. Please enter an IB S/N that is 20 characters or less.");
    }
  };

  const setIbValidation = (valid, message, type) => {
    setValidIbValue(valid);
    setIbValueValidationMessage(message || "");
    setIbValueValidationType(type || "error");
  };

  const closeIbValueError = () => {
    setIbValidation(true);
  };

  const onChangeOB = (event) => {
    const value = event.target.value;
    const isValidOB = value.match(/[^A-Za-z0-9\s/-]/gi);
    let newObValue = value.replace(/[^A-Za-z0-9\s/-]/gi, "");
    const attemptExceed = newObValue.length > 20;
    newObValue = newObValue.substring(0, 20);
    setObValue(newObValue);
    if (isValidOB) {
      setOBValidation(false, "OB S/N is not valid. The OB S/N cannot contain special characters.");
    } else if (attemptExceed) {
      setOBValidation(false, "OB S/N is not valid. Please enter an OB S/N that is 20 characters or less.");
    }
  };

  const closeOBValueError = () => {
    setOBValidation(true);
  };

  const setOBValidation = (valid, message, type) => {
    setValidObValue(valid);
    setValidationMessageForOB(message || "");
    setObValidationType(type || "error");
  };

  const onChangeEffectivity = (effectivities) => {
    setEffectivities(effectivities);
    populatePartValue(effectivities);
    setParts(null);
    if (effectivities.length > 0) {
      setPartDisabled(false);
    } else {
      setPartDisabled(true);
    }
  };

  const onChangePart = (parts) => {
    if(parts.label.includes('WHEEL')){
      setSNValue("");
      closeIbValueError();
      closeOBValueError();
      closeSnError();
      setIsWheelOrBreak('WHEEL')
    } else {
      setIbValue("");
      setObValue("");
      closeIbValueError();
      closeOBValueError();
      closeSnError();
      setIsWheelOrBreak('BRAKE')
    }
    setParts(parts);
  };

  const populatePartValue = (effectivities) => {
    const effectivitiesArray = effectivities.map(item => item.value);
    const dropDownPartAllValues = partValue
      .filter((element, i, array) => {
        return effectivitiesArray.includes(element.EFFECTIVITY_ID);
      })
      .map((q, index) => ({
        label: (q["PART_TYPE_CODE"] + ' : ' + q["PART_ID"]),
        value: [q["PART_ID"], q["DESCRIPTION"]],
      }))
      .sort(compare)
      .filter((element, i, array) => {
        if (i > 0) {
          const sliceAr = array.slice(0, i);
          const foundedElement = sliceAr.find(a => a.label === element.label);
          if (foundedElement) return false;
        }
        return true;
      });
    SetDropDownPartValues(dropDownPartAllValues);
  }

  const dropDownEffectivities = [{
    options: partValue.map((e, index) => ({
      label: (e["EFFECTIVITY_ID"]),
      value: (e["EFFECTIVITY_ID"]),
    }))
      .sort(compare)
      .filter((element, e, arr) => {
        if (e > 0) {
          const sliceArr = arr.slice(0, e);
          const duplicateEffectiviy = sliceArr.find(e => e.label === element.label);
          if (duplicateEffectiviy) return false;
        }
        return true;
      })
  }]

  const dropDownStationCodes = [{
    options: printerValue.map((prin, index) => ({
      label: (prin["STATION_CODE"]),
      value: (prin["STATION_CODE"])
    }))
      .sort(compare)
      .filter((element, p, arr) => {
        if (p > 0) {
          const array = arr.slice(0, p);
          const matchingElement = array.find(pri => pri.label === element.label);
          if (matchingElement) {
            return false;
          }
        }
        return true;
      }),
  }]

  const dropDownPrinterValues = [{
    options: printerValue.map((prin, index) => ({
      label: (prin["PRINTER_ID"]),
      value: (prin["PRINTER_ID"])
    }))
      .sort(compare)
      .filter((curr) => {
        // Retrieve Printer object based on printer name (PRINTER_ID)
        let matchingPrinterObject = printerValue.find(ele => ele.PRINTER_ID === curr.label);
        // Compare selected station code value to printer object station code and return if true
        return matchingPrinterObject.STATION_CODE === stationCodes.value;
      })
  }]

  const onChangeStationCode = (stationCodes) => {
    setstationCodes(stationCodes);
    setPrinter("");
  };

  const onChangePrinter = (printers) => {
    setPrinter(printers);
  };

  const onCancel = () => {
    setShowAlert(true);
  };

  const onClickModalYes = () => {
    setEffectivities([]);
    setFtnValue("");
    setIbValue("");
    setObValue("");
    setSNValue("");
    setPrinter("");
    setParts("");
    closeFTNValueError();
    closeIbValueError();
    closeOBValueError();
    closeSnError();
    setstationCodes([]);
    setShowAlert(false);
  };

  const onClickModalNo = () => {
    setShowAlert(false);
  };

  const onPrint = () => {
    setIsPrinting(true);
    let body = {
        "PART_ID": {
          "S": parts ? parts.value[0] : ""
        },
        "DESCRIPTION": {
          "S": parts ? parts.value[1] : ""
        },
        "FTN_WO": {
          "S": ftnValue || ""
        },
        "IB_SN": {
          "S": ibValue || ""
        },
        "OB_SN": {
          "S": obValue || ""
        },
        "BRAKE_SN": {
          "S": snValue || ""
        },
        "PRINTER_ID": {
          "S": printer ? printer.value : ""
        },
        "STATION_CODE": {
          "S": stationCodes ? stationCodes.value : ""
        },
        "EXPIRES": {
            "S": "NEW"
        },
        "PRINT_TYPE": {
            "S": "NEW"
        },
        "ACCESS_TOKEN": {
            "S": JSON.parse(sessionStorage.getItem(ACCESS_TOKEN_KEY)).accessToken
        }
    };
    create("TAGS", body).then(resp => {
      setIsPrinting(false);
      if (resp.statusCode === 200) {
        setShowSaveAlert(true);
        setSaveMessage("Tag has been printed on printer \"" + printer.value + "\".");
        setIbValue("");
        setObValue("");
        setSNValue("");
      } else {
        let errMsg = resp.body.message;  
        setShowNotSavedAlert(true);
        setSaveErrorMessage(errMsg);
      }
    }).catch(err => {
      setIsPrinting(false);
      setShowNotSavedAlert(true);
      setSaveErrorMessage("Failed to print tag. Please try again.");
    });
  };

  const onClickNew = () => {
    window.location.reload();
  };

  const onClickShowList = () => {
    navigate('/tag-list');
  };

  const onClickOkSaveError = () => {
    setShowNotSavedAlert(false);
  };

  const onClickOkSaveSuccess = () => {
    setShowSaveAlert(false);
  };

  return (
    <div className="form-main">
      <Form className="create-form tag-form">
        <div className="form-header">
          <div>Create Tag</div>
          <div className="header-note"><span style={{ color: 'var(--southwest-red)' }}>&#10045;</span> denotes a mandatory field</div>
        </div>

        <Form.Group className="form-textfield">
          <Form.Label className="wnb-label userCls">UserId<span style={{ color: 'var(--southwest-red)', paddingLeft: '2px' }}>&#10045;</span></Form.Label>
          <Form.Label className="wnb-label">{decodeToken(JSON.parse(sessionStorage.getItem(ACCESS_TOKEN_KEY))).userId}</Form.Label>
        </Form.Group>

        <Form.Group className="form-textfield">
          <Form.Label className="wnb-label stnCls">Station Code<span style={{ color: 'var(--southwest-red)', paddingLeft: '2px' }}>&#10045;</span></Form.Label>
          <Select className="dropDownCls" options={dropDownStationCodes} placeholder="Select a Station Code" value={stationCodes} onChange={onChangeStationCode} />
        </Form.Group>

        <Form.Group className="form-textfield">
          <Form.Label className="wnb-label prntCls">Printer<span style={{ color: 'var(--southwest-red)', paddingLeft: '2px' }}>&#10045;</span></Form.Label>
          <Select className="dropDownCls" options={dropDownPrinterValues} isDisabled={stationCodes.length === 0} placeholder="Select a Printer" value={printer} onChange={onChangePrinter} />
        </Form.Group>

        <Form.Group className="form-textfield">
          <Form.Label className="wnb-label efCls">Effectivity<span style={{ color: 'var(--southwest-red)', paddingLeft: '2px' }}>&#10045;</span></Form.Label>
          <Select className="effectivity-combobox" options={dropDownEffectivities} isMulti placeholder="Select Effectivity" value={effectivities} onChange={onChangeEffectivity} />
        </Form.Group>

        <Form.Group className="form-textfield">
          <Form.Label className="wnb-label partCls">Part<span style={{ color: 'var(--southwest-red)', paddingLeft: '2px' }}>&#10045;</span></Form.Label>
          <Select className="dropDownCls" isDisabled={partDisabled} options={dropDownPartValues} placeholder="Select Part" value={parts} onChange={onChangePart} />
        </Form.Group>

        <Form.Group className="form-textfield">
          <Form.Label className="wnb-label ftnCls">FTN or WO<span style={{ color: 'var(--southwest-red)', paddingLeft: '2px' }}>&#10045;</span></Form.Label>
          <div className="field-control marginCls">
            <Form.Control
              type="ftnValue"
              value={ftnValue}
              className={(!validFtnValue && 'ftnClass invalid-field-' + ftnValidationType) || 'ftnClass'}
              placeholder="Enter FTN or WO"
              onChange={onChangeFTNWO}
            />
            <FieldValidation show={!validFtnValue} message={validationMessageForFTNWO} type={ftnValidationType} onClose={closeFTNValueError} />
          </div>
        </Form.Group>

        {(isWheelOrBreak === 'WHEEL' || !isWheelOrBreak) && (<><Form.Group className="form-textfield">
          <Form.Label className="wnb-label obCls">OB S/N<span style={{ color: 'var(--southwest-red)', paddingLeft: '2px' }}>&#10045;</span></Form.Label>
          <div className="field-control marginCls">
            <Form.Control
              type="obValue"
              value={obValue}
              className={(!validObValue && 'obClass invalid-field-' + obValueValidationType) || 'obClass'}
              placeholder="Enter OB S/N"
              onChange={onChangeOB}
            />
            <FieldValidation show={!validObValue} message={validationMessageForOB} type={obValueValidationType} onClose={closeOBValueError} />
          </div>
        </Form.Group>

          <Form.Group className="form-textfield">
            <Form.Label className="wnb-label ibCls">IB S/N<span style={{ color: 'var(--southwest-red)', paddingLeft: '2px' }}>&#10045;</span></Form.Label>
            <div className="field-control marginCls">
              <Form.Control
                type="ibValue"
                value={ibValue}
                className={(!validIbValue && 'ibClass invalid-field-' + ibValueValidationType) || 'ibClass'}
                placeholder="Enter IB S/N"
                onChange={onChangeIbValue}
              />
              <FieldValidation show={!validIbValue} message={ibValueValidationMessage} type={ibValueValidationType} onClose={closeIbValueError} />
            </div>
          </Form.Group></>)}

        {isWheelOrBreak === 'BRAKE' && (<><Form.Group className="form-textfield">
          <Form.Label className="wnb-label snCls">Brake S/N<span style={{ color: 'var(--southwest-red)', paddingLeft: '2px' }}>&#10045;</span></Form.Label>
          <div className="field-control marginCls">
            <Form.Control
              type="snValue"
              value={snValue}
              className={(!validSnValue && 'snClass invalid-field-' + snValidationType) || 'snClass'}
              placeholder="Enter Brake S/N "
              onChange={onChangeSN}
            />
            <FieldValidation show={!validSnValue} type={snValidationType} message={snValueValidationMessage} onClose={closeSnError} />
          </div>
        </Form.Group></>)}

        <Form.Group className="action-panel">
          <Button disabled={!!!ftnValue || effectivities.length === 0 || !!!parts || !!!printer
            || !!!stationCodes || !!!validFtnValue || !!!validIbValue || !!!validObValue || !!!validSnValue || ((isWheelOrBreak === 'BRAKE') ? !!!snValue : (!!!ibValue || !!!obValue))} onClick={onPrint}>Print</Button>
          <Button variant="secondary" onClick={onCancel}>Cancel</Button>
        </Form.Group>
      </Form>
      <WnbModal
        title="Warning"
        message="Are you sure you wish to cancel?  Clicking YES will reset all data."
        handleCancel={onClickModalNo}
        handleYes={onClickModalYes}
        showAlert={showAlert}
      />
      <WnbModalSuccess
        title="Success"
        message={saveMessage}
        handleOk={onClickOkSaveSuccess}
        handleNew={onClickNew}
        handleShowList={onClickShowList}
        showAlert={showSaveAlert}
      />
      <WnbModalLoading
        showAlert={isPrinting}
        message="Sending tag to printer..."
      />
      <WnbModalError
        title="Error"
        message={saveErrorMessage}
        handleOk={onClickOkSaveError}
        showAlert={showNotSavedAlert}
      />
    </div>
  );
};

export default TagForm;
